import { useGetSubscriptionQuery } from '@/store/api/apiSlice';
import { useBillingCTA } from '@/hooks/useBillingCTA';
import { FiAlertTriangle, FiInfo } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TrialStatusBanner() {
  const { t } = useTranslation();
  const { data: subscription } = useGetSubscriptionQuery(undefined);
  const billingState = subscription?.billingState;
  const billingConfigured = subscription?.billingConfigured ?? false;
  const onTrial =
    billingState?.planState === 'trial_local' || billingState?.planState === 'trialing_billing';
  const cta = useBillingCTA(billingState, !!subscription?.billing, { billingConfigured });

  if (!cta.bannerMessage) return null;

  const isWarning = cta.bannerSeverity === 'warning' || cta.bannerSeverity === 'error';
  const Icon = isWarning ? FiAlertTriangle : FiInfo;

  return (
    <div
      className={`trial-status-banner shrink-0 px-4 py-[0.2rem] flex flex-wrap items-center justify-between gap-2 text-[11px] ${
        isWarning
          ? 'bg-amber-50 text-amber-900'
          : 'bg-indigo-50 text-indigo-900'
      }`}
      role="status"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Icon className="shrink-0" size={16} />
        <span className="font-medium">{cta.bannerMessage}</span>
      </div>
      {(billingState?.needsPlanPayment || (onTrial && billingConfigured)) && (
        <Link
          to="/billing?tab=products"
          className="shrink-0 font-semibold underline underline-offset-2 hover:opacity-80"
        >
          {cta.primaryLabel ?? t('billing.goToBilling')}
        </Link>
      )}
    </div>
  );
}
